import { render, staticRenderFns } from "./NotVerified.vue?vue&type=template&id=6818c3c6&"
import script from "./NotVerified.vue?vue&type=script&lang=js&"
export * from "./NotVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports